import { render } from "./FamilyHealthHistory.vue?vue&type=template&id=7745ff22&ts=true"
import script from "./FamilyHealthHistory.ts?vue&type=script&lang=ts&external"
export * from "./FamilyHealthHistory.ts?vue&type=script&lang=ts&external"

import "./FamilyHealthHistory.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__